// extracted by mini-css-extract-plugin
module.exports = {"form":"_2gebTVM","buttons":"_1M-h5ms"};